/**
 * Helper functions for handling models, columns and data lists
 */

import { ModelFactory, columnDefinition } from './ModelFactory'

/**
 * @param model
 * @return {{}}
 * @private
 */
export function createNew(model: ModelFactory): object {
  const newRec = {}
  model.colNames.map((r) =>
    model.columns[r]?.default !== undefined ? (newRec[r] = model.columns[r].default) : '',
  )
  return newRec
}

export function getColsWithAssocs(
  model: ModelFactory,
  models: { [modelName: string]: ModelFactory },
  modelAssociationDefs: object,
) {
  let assocColsFlat = {}
  if (modelAssociationDefs) {
    Object.keys(modelAssociationDefs).map((assocType) => {
      Object.keys(modelAssociationDefs[assocType]).map((m) => {
        if (modelAssociationDefs[assocType][m].fields) {
          Object.keys(modelAssociationDefs[assocType][m].fields).map((c) => {
            assocColsFlat[`${m}.${c}`] = models[m].columns[c]
          })
        } else {
          models[m].colNames.map((c) => {
            assocColsFlat[`${m}.${c}`] = models[m].columns[c]
          })
        }
      })
    })
  }
  return Object.assign({}, model.columns, assocColsFlat)
}

/**
 * Association定義における、テーブル名とフィールドのオブジェクトを返す
 * @param model
 * @param modelAssociations
 * @return {{}}
 * @private
 * Ex: _getColTableMap(materialOrdersModel, { hasMany: { material_order_delivers: { fields: {} } } })
 *   => response: { material_orders: [...colNames], material_order_delivers: [...colNames] }
 */
export function getColTableMap(model, modelAssociations) {
  let mapping = {}
  mapping[model.tableName] = model.colNames
    .map((c) => (model.columns[c].visible === false ? false : c))
    .filter((v) => !!v)
  if (modelAssociations) {
    Object.keys(modelAssociations).map((assocType) => {
      Object.keys(modelAssociations[assocType]).map((m) => {
        mapping[m] = Object.keys(modelAssociations[assocType][m].fields)
      })
    })
  }
  return mapping
}
